export const SEARCH_PHRASE_MIN_LENGTH = 2;
